// ====================
// Paidy 金額切り替え
// ====================
document.addEventListener("DOMContentLoaded", function() {
    const selections = {};
    const categories =
    Array.from(document.querySelectorAll('input[type="radio"]'))
    .filter(input => input.id.includes('__main-'));
    const updateSelections = (input) => {
    if (input.checked) {
    selections[input.name] = input.value;
    }
    };
    const getPriceInCents = (combinedSelection) => {
    const variant = meta.product.variants.find(variant =>
    variant.public_title === combinedSelection);
    return variant ? variant.price : null;
    };
    const refreshWidget = (price) => {
    const widget =
    document.querySelector("._paidy-promotional-messaging");
    widget.setAttribute("data-amount", price);
    if (typeof _paidy === 'function') {
    _paidy("pm:refresh");
}
};
const updatePrice = () => {
const combinedSelection = Object.values(selections).join(' / ');
const priceInCents = getPriceInCents(combinedSelection);
if (priceInCents) {
const price = (priceInCents / 100).toFixed(2);
refreshWidget(price);
}
};
categories.forEach(updateSelections);
updatePrice();
categories.forEach(input => {
input.addEventListener('change', (event) => {
selections[event.target.name] = event.target.value;
updatePrice();
});
});
});